export default __webpack_public_path__ + "static/media/install_app.6e1f380c.svg";